import { Component, signal } from '@angular/core';
import { AuthenticationService } from '../../authentication/auth.service';

@Component({
    selector: 'app-about',
    templateUrl: './about.component.html',
    styleUrls: ['./about.component.css'],
    standalone: false
})
export class AboutComponent {
  modalAccountOpen: boolean = false;
  readonly globalVersion = signal('');
  readonly serviceRegion = signal('');

  constructor(private auth: AuthenticationService) {
    this.auth.getFrontendConfig().then(config => {
      this.globalVersion.set(config.globalVersion ?? "");
    });

    this.auth.isAuthenticatedObservable().subscribe(isAuthenticated => {
      if (isAuthenticated) {
        const region = this.auth.getServiceRegion();
        this.serviceRegion.set(region ? region.description : '');
      }
    });
  }

  public openAbout() {
    this.modalAccountOpen = true;
  }
}
